import {Component, ElementRef} from '@angular/core';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
})
export class InfoComponent {

  constructor(private elRef: ElementRef) {
  }

  scrollIntoView(): any {
    this.elRef.nativeElement.scrollIntoView();
  }
}
